import { INITIAL_STATE_BASE_INTERFACE } from './chunk-3YIOW4BW.mjs';
import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/specials_initialState.ts
var SPECIAL_AVAILABILITY_TIME_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  locationMenuTypeSpecialId: 0,
  day: "monday" /* MONDAY */,
  startTime: "",
  endTime: "",
  createdAt: null,
  updatedAt: null,
  deletedAt: null
});
var SPECIAL_MENU_TYPE_VERSION_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  menuTypeId: 0,
  locationId: 0,
  locationMenuTypeSpecialId: 0,
  locationMenuTypeSpecialVersionId: 0,
  menuTypeSpecialId: 0,
  mimicItems: false,
  specialApplyTo: "item" /* ITEM */,
  thresholdAmount: 0,
  posName: "",
  checkName: "",
  description: "",
  active: true,
  buyQuantity: 0,
  discountAmount: 0,
  discountType: "fixed" /* FIXED */,
  getItemIds: [],
  getQuantity: 0,
  availableTimes: {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  },
  buyItemIds: [],
  buyComboIds: [],
  getComboIds: []
});
var SPECIAL_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  organizationId: 0,
  specialId: 0,
  createdByLocationId: 0,
  name: "",
  menuTypeVersions: {
    "0": SPECIAL_MENU_TYPE_VERSION_INITIAL_STATE
  },
  locationIds: []
});
var SPECIAL_INITIAL_STATE_FOR_SAVING = __spreadProps(__spreadValues({}, SPECIAL_INITIAL_STATE), {
  menuTypeVersions: {}
});

export { SPECIAL_AVAILABILITY_TIME_INITIAL_STATE, SPECIAL_INITIAL_STATE, SPECIAL_INITIAL_STATE_FOR_SAVING, SPECIAL_MENU_TYPE_VERSION_INITIAL_STATE };
